/**
 * Maps a URL pathname to the shared announcement page-key enum used by the admin
 * UI and the backend. Keep this in sync with PAGE_KEYS in charti-admin
 * (AnnouncementForm.tsx) and PAGE_KEYS in charti-ai-api (schemas_announcements.py).
 */

export type AnnouncementPageKey =
  | "home"
  | "sessions"
  | "session_detail"
  | "templates"
  | "patients"
  | "billing"
  | "settings"
  | "login";

export function pathnameToPageKey(pathname: string): AnnouncementPageKey | null {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (p === "/home" || p === "/") return "home";
  if (p === "/sessions") return "sessions";
  if (p.startsWith("/sessions/")) return "session_detail";
  if (p === "/templates") return "templates";
  if (p === "/patients" || p.startsWith("/patients/")) return "patients";
  if (p.startsWith("/billing")) return "billing";
  if (p === "/settings" || p.startsWith("/settings/")) return "settings";
  if (
    p === "/login" ||
    p === "/signup" ||
    p === "/forgot-password" ||
    p === "/reset-password" ||
    p === "/verify-email" ||
    p === "/email-verification" ||
    p === "/check-email" ||
    p === "/sso-callback"
  ) {
    return "login";
  }
  return null;
}
